"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var search_1 = require("./search");
exports.SearchService = search_1.SearchService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/services/index.ts
// module id = 469
// module chunks = 0